import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'sem-registro',
  templateUrl: 'sem-registro.html',
  styleUrls: ['./sem-registro.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
})
export class SemRegistroComponent {
  @Input()
  text: string;

  @Input()
  notFound = true;
  isMessianica = false;

  constructor(private translateService: TranslateService) {
    this.isMessianica = environment.isMessianica;
    this.text = this.translateService.instant('Nenhum registro localizado');
  }
}
